import { render, staticRenderFns } from "./KpiRow.vue?vue&type=template&id=e458ce1a&scoped=true"
import script from "./KpiRow.vue?vue&type=script&lang=js"
export * from "./KpiRow.vue?vue&type=script&lang=js"
import style0 from "./KpiRow.vue?vue&type=style&index=0&id=e458ce1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e458ce1a",
  null
  
)

export default component.exports